/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
import Requests from './network/network_requests';

export function logOutAccess() {
  const promise = new Promise(function (resolve, reject) {
    Requests.post('/logout/access', {}).then(function (result) {
      resolve(true);
    });
  });
  return promise;
}

export function logOutRefresh() {
  const promise = new Promise(function (resolve, reject) {
    Requests.postWithCredentials('/logout/refresh', {}, true).then(function (
      result,
    ) {
      resolve(true);
    });
  });
  return promise;
}

export function findGetParameter(parameterName) {
  let result = null;
  let tmp = [];
  window.location.search
    .substr(1)
    .split('&')
    .forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

// Promise for rejecting bad API requests.
const rejectErrors = (resp) => {
  if (!resp || resp.error) {
    resp = resp || {};
    const error = resp.error
      ? resp.error
      : 'An error occurred. Please try again.';
    console.log(error);
    throw error;
  }
  return resp;
};

export { rejectErrors };
